var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#821BB8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4A2.5 2.5 0 0 1 23 6.5V24a4 4 0 0 0 4 4H7a4 4 0 0 1-4-4V6.5A2.5 2.5 0 0 1 5.5 4zM18 21H8a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zm0-4H8a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zm0-4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm-6-4H8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 9h2.5a1.5 1.5 0 0 1 1.5 1.5V24a2 2 0 1 1-4 0V9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.6249a000c6756674546d80de5f8b2681.svg";
export { ForwardRef as ReactComponent };